// src/screens/FinanzasScreen.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { collection, query, where, onSnapshot, orderBy } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import {
  IoArrowBack,
  IoDownloadOutline,
  IoDocumentTextOutline,
  IoShieldCheckmarkOutline,
  IoWalletOutline
} from 'react-icons/io5';
import moment from 'moment';
import 'moment/locale/es';
import './FinanzasScreen.css';
import './FinanzasScreen.css';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBottomNav from '../components/Shared/KondoBottomNav';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';

function FinanzasScreen() {
  const navigate = useNavigate();
  const { userData } = useAuth();
  const [reportes, setReportes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userData?.condominioId) return;

    const q = query(
      collection(db, "reportesFinancieros"),
      where("condominioId", "==", userData.condominioId),
      orderBy("anio", "desc"),
      orderBy("mes", "desc")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const listaReportes = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setReportes(listaReportes);
      setLoading(false);
    }, (error) => {
      console.error("Error al cargar reportes financieros: ", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [userData]);

  const getNombreMes = (numMes) => {
    return moment(numMes, 'M').format('MMMM');
  }

  return (
    <div className="ks-page">
      <KondoSidebar activeRoute="/finanzas" />
      <main className="ks-main">
        <div className="ks-header-sticky-wrapper">
          <KondoBrandHeader showBack={false} />
        </div>
        <div className="ks-scroll-area">
          <div className="muro-header-stitch">
            <div className="muro-hero-card">
              <div className="muro-hero-content">
                <h1>Finanzas</h1>
                <p>Transparencia y Presupuesto</p>
              </div>
              <IoDocumentTextOutline className="muro-hero-icon-decor" />
            </div>
          </div>
          <div className="finanzas-container">

      {loading ? (
        <p style={{ textAlign: 'center', padding: '40px', color: '#9ca3af' }}>Cargando reportes...</p>
      ) : reportes.length === 0 ? (
        <div className="empty-reports">
          <IoDocumentTextOutline size={60} style={{ opacity: 0.3, marginBottom: '15px' }} />
          <h3>No hay reportes publicados</h3>
          <p>La administración aún no ha subido reportes financieros.</p>
        </div>
      ) : (
        <div className="reports-grid">
          {reportes.map(reporte => (
            <div key={reporte.id} className="fin-card-compact">
              <div className="fin-icon-box">
                <IoDocumentTextOutline />
              </div>
              <div className="fin-info">
                <div className="fin-title">{reporte.titulo}</div>
                <div className="fin-meta">
                  {getNombreMes(reporte.mes)} {reporte.anio}
                </div>
              </div>
              <a
                href={reporte.archivoUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="fin-download-btn"
                title="Descargar PDF"
              >
                <IoDownloadOutline size={20} />
              </a>
            </div>
          ))}
        </div>
      )}
          </div>
        </div>
        {/* ── FLOATING ISLAND BOTTOM NAV (mobile) ── */}
        <KondoBottomNav activeRoute="/finanzas" />
      </main>
    </div>
  );
}

export default FinanzasScreen;